export default __webpack_public_path__ + "static/media/p3.620b113d.jpg";